import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  // Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const LeftSidebar = () => {
  const username = localStorage.getItem('username');
  const empcode = localStorage.getItem('empcode');

  return (
    <Box
      sx={{
        width: 250,
        p: 2,
        backgroundColor: '#f4f9fb',
        height: '120vh',
        borderRight: '1px solid #d3e0e9',
        marginBottom: '70px'

      }}
    >
      {/* User Info */}
      <Paper elevation={3} sx={{ p: 2, mb: 2, borderLeft: '5px solid #35bfcd' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
          User Info
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '13px' }}>
          <strong>Name:</strong> {username}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '13px' }}>
          <strong>Employee Code:</strong> {empcode}
        </Typography>
      </Paper>

      {/* Welcome Message */}
      <Paper elevation={3} sx={{ p: 2, mb: 2, borderLeft: '5px solid #35bfcd' }}>
        <img
        src={`${process.env.PUBLIC_URL}/attendancepunch.jpg`}
         // src="https://apps.genus.in/NIVARAN/img/attendancepunch.jpg"  // image in public folder
          alt="Genus Logo"
          style={{ width: '100%', borderRadius: '6px' }}
        />
        <Box sx={{ mt: 1, backgroundColor: '#eef6fb', p: 1, borderRadius: 1 }}>
          <Typography variant="body2" sx={{ fontSize: '13px' }}>
            Welcome back! We hope you have a productive day!
          </Typography>
        </Box>
      </Paper>

      {/* Quick Links */}
      <Paper elevation={3} sx={{ p: 2, mb: 2, borderLeft: '5px solid #35bfcd' }}>
        <Typography variant="subtitle2" sx={{ fontSize: '14px', fontWeight: 'bold', mb: 1 }}>
          Quick Links
        </Typography>
        <List dense>
          <ListItem button component={NavLink} to="/home">
            <ListItemIcon><DashboardIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button component={NavLink} to="/HolidayCalendar">
            <ListItemIcon><CalendarMonthIcon fontSize="small" /></ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: '13px' }} primary="Holiday List" />
          </ListItem>
          <ListItem button component={NavLink} to="/help">
            <ListItemIcon><ContactMailIcon fontSize="small" /></ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: '13px' }} primary="Contact Us" />
          </ListItem>
        </List>
      </Paper>

      {/* Thought Box */}
      <Paper elevation={3} sx={{ p: 2, display: 'flex', alignItems: 'center', borderLeft: '5px solid #35bfcd' }}>
        <LightbulbIcon sx={{ color: '#ffc107', mr: 1 }} fontSize="small" />
        <Typography variant="body2" sx={{ fontStyle: 'italic', fontSize: '13px' }}>
          "Success usually comes to those who are too busy to be looking for it." – Henry David Thoreau
        </Typography>
      </Paper>
    </Box>
  );
};

export default LeftSidebar;
